import dayjs from "dayjs";

// INFO - M.S - 20/05/2021 - flatten the responseObject
// example :
//
// {             {
//   a:2,         a:2,
//   b: {   ==>   c:3
//     c:3       }
//   }
// }
const flattenObject = (obj) => {
  const flattened = {};
  Object.keys(obj).forEach((key) => {
    if (!Array.isArray(obj[key]) && obj[key] instanceof Object) {
      Object.assign(flattened, flattenObject(obj[key]));
    } else {
      flattened[key] = obj[key];
    }
  });
  return flattened;
};

export const snakeToCamel = (data, flatten) => {
  if (!data) {
    return;
  }
  if (flatten === "flatten") {
    data = flattenObject(data);
  }

  Object.keys(data).forEach((key) => {
    if (key.includes("_")) {
      let newKey = key.replace(/(_[a-z])/g, (match) => match.toUpperCase().replace("_", ""));
      Object.assign(data, { [newKey]: data[key] });
      delete data[key];
    }
  });
  return data;
};

export const chunkArray = (array, chunkSize) => {
  const chunks = [];
  for (let i = 0; i < array.length; i += chunkSize) {
    chunks.push(array.slice(i, i + chunkSize));
  }
  return chunks;
};

export const cleanDatetimes = (object, keys) => {
  if (!object) return;
  for (const key of keys) {
    if (object[key]) {
      object[key] = dayjs(object[key]);
    } else {
      delete object[key];
    }
  }
  return object;
};

// A.S 24/08/26 Les SDK OpenAPI renvoient des objets `Date` pour les champs date-time,
// là où gRPC renvoyait des chaînes. pinia-orm attend des chaînes : on normalise avant
// insertion, sans toucher au reste de la structure.
export const serializeDatesDeep = (value) => {
  if (value instanceof Date) return value.toISOString();
  if (Array.isArray(value)) return value.map(serializeDatesDeep);
  if (value && typeof value === "object") {
    return Object.fromEntries(
      Object.entries(value).map(([key, item]) => [key, serializeDatesDeep(item)]),
    );
  }
  return value;
};
